<template lang="pug">
v-row
  v-col(cols=12, lg=5, v-if="(mobile && !showMap) || !mobile")
    v-tabs(v-model="tab")
      v-tab 1. Current Car
      v-tab 2. Add Trips
      v-tab 3. Results
    v-tabs-items.full-height-tab(v-model="tab")
      v-tab-item
        HomeBase.ma-0.pa-1(
          @next="nextTab(1)",
          @skip="skipTab(0)",
          :bubble="bubble",
          :settings="settings",
          :sortedCars="sortedCars"
        )
      v-tab-item
        AddTrips.ma-0.pa-1(
          :trips="trips",
          @next="nextTab(2)",
          @skip="skipTab(1)",
          :settings="settings",
          :bubble="bubble"
        )
      v-tab-item
        Results.ma-0.pa-1(
          :sortedCars="sortedCars",
          :bubble="bubble",
          :settings="settings",
          :trips="trips",
          @show-settings="dialog = true"
        )
  v-col(cols=12, lg=7)
    Map(
      v-if="(mobile && showMap) || !mobile",
      :homeAddress="bubble.location",
      :radarMarkers="chargerMarkers",
      :routeMarkers="chargersOnAllRoutes",
      :trips="trips",
      @clickedLocation="clickedLocation",
      :car="sortedCars[bubble.userPref]",
      :settings="settings",
      :spiderweb="paths",
      :splat="rangeSplat",
      @centerRadar="clickedLocation",
      @mapUpdate="mapUpdated",
      ref="myMap"
    )
</template>

<script>
import HomeBase from "../components/HomeBase.vue";
import AddTrips from "../components/AddTrips.vue";
import Map from "../components/Map.vue";
import Results from "../components/Results.vue";
import PowerTrip from "../services/api/PowerTrip.js";
import EVNav from "../services/api/EVNav.js";
import { headerBus } from "../main";
//import arc from 'arc';
export default {
  data() {
    return {
      mapVisible: false,
      bubble: this.$bubble,
      settings: this.$dealer.user_settings,
      tab: "tab-" + this.$route.params.id,
      dialog: false,
      chargers: [],
      web: [],
      radarChargers: [],
      trips: this.$trips,
      mapUpdate: 0,
      chosenCar: 0,
      driver: {
        aa: 50,
        sa: 0,
        soh: 100,
        battery: 100,
        passengers: 1,
        batteryMin: 20,
        batteryMax: 95,
        extraWeight: 0,
      },
    };
  },
  created() {
    headerBus.$on("toggleMap", () => {
      this.mapVisible = !this.mapVisible;
    });
  },
  computed: {
          paths() {
        let paths = [];
        if(this.$refs.myMap && this.chargerMarkers && this.$refs.myMap.$refs.markers) {
              let refs = this.$refs.myMap.$refs;
              console.log(refs);
              for (let i = 0; i < this.chargerMarkers.length; i++) {
                  let marker = this.$refs.myMap.$refs.markers[i].mapObject;
                  let r = this.$refs.myMap.$refs.radarCluster.mapObject.getVisibleParent(marker);
                  if (r) {
                    if (r._leaflet_id == marker._leaflet_id && paths.length < 20) {
                      let m = this.chargerMarkers[i];

                      paths.push({id:m.ID,path:m.Path,EnergyPercent:m.EnergyPercent});
                    }
                  }
              }
        }
      return paths;
      },
    rangeSplat() {
      if (this.bubble.location.Address.Address == "") {
        return [];
      }
      var points = this.chargerMarkers.map((e) => [parseFloat(e.LatLng.lat),parseFloat(e.LatLng.lng)]);

      return this.convexHull(points);
    },
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        default:
          return false;
      }
    },
    showMap() {
      if (this.$vuetify.breakpoint.name == "lg") {
        return true;
      }
      return this.mapVisible;
    },
    sortedCars: function () {
      console.log(this.cars);
      let arrCopy = JSON.parse(JSON.stringify(this.cars));
      let homeLocation = this.latlngFromLocation(this.bubble.location);

      for (let car of arrCopy) {
        car.Range = this.calculateRange(car, homeLocation);
        car.Consumption = this.calculateKmPerKwh(car, homeLocation);
        car.Unsuitable = car.Range < this.bubble.kms / 7;
        car.RunningCosts = this.calculateRunningCosts(
          car,
          this.bubble,
          this.settings,
          this.trips,
          this.bubble.savingsMode != "home"
        );
        if (this.bubble.savingsMode == "both") {
          car.RunningCosts += this.calculateRunningCosts(
            car,
            this.bubble,
            this.settings,
            this.trips,
            false
          );
        }
        car.PetrolEquivilent = this.calculatePetrolCosts(
          this.bubble,
          this.settings,
          this.trips,
          this.bubble.savingsMode != "home"
        );
        if (this.bubble.savingsMode == "both") {
          car.PetrolEquivilent += this.calculatePetrolCosts(
            this.bubble,
            this.settings,
            this.trips,
            false
          );
        }
        car.CO2Savings = this.calculateCO2Savings(
          car,
          this.bubble,
          this.settings,
          this.trips,
          this.bubble.savingsMode != "home"
        );
        if (this.bubble.savingsMode == "both") {
          car.CO2Savings += this.calculateCO2Savings(
            car,
            this.bubble,
            this.settings,
            this.trips,
            false
          );
        }
        car.ChargingStops = this.calculateChargingStops(
          car,
          this.bubble,
          this.settings,
          this.trips,
          this.bubble.savingsMode != "home"
        );
        car.TCO =
          car.Price +
          (car.RunningCosts - this.settings.annualMaintenanceEV) * 5 -
          (car.PetrolEquivilent -
            this.settings.annualMaintenanceICE -
            (this.settings.annualMaintenanceICE -
              this.settings.annualMaintenanceEV)) *
            5 +
          car.ChargingStops * this.settings.recommendationAdjustmentFactor * 5;
      }
      //Sorted by suitable based on the radar data.
      this.findRecommendedCar(arrCopy);

      return arrCopy;
    },
    chargerMarkers: function () {
      if (this.bubble.location.Address == null) {
        return [];
      }

      let markers = [];
      let src = {
        lat: this.bubble.location.Address.geometry.coordinates[1],
        lng: this.bubble.location.Address.geometry.coordinates[0],
      };
      if (this.sortedCars.length > 0 && this.radarChargers) {
        for (let i = 0; i < this.chargers.length; i++) {
          let c = this.chargers[i];
          let rc = this.radarChargers.find((e) => e.id == c.ID);
          if (rc) {
            let m = {};
            m.Name = c.Title;
            m.ID = c.ID;
            m.Current = c.Current;
            m.KwRated = c.KwRated;
            m.Charger = c;
            let dst = { lat: rc.location[1], lng: rc.location[0] };
            m.EnergyPercent =
              (rc.energy_used /
                parseFloat(this.sortedCars[this.bubble.userPref].BatterySize)) *
              100;
            m.Path = [
              {lng: src.lng, lat: src.lat},
              {lng: dst.lng, lat: dst.lat},
            ];
            m.LatLng = { lat: c.Latitude, lng: c.Longitude };
            markers.push(m);
          }
        }
      }
      return markers;
    },
    chargersOnRoute: function (trip) {
      let metres = 5 * 1000; //Divert no more than 5km to find a charger
      let routeChargers = [];
      let points = this.getPoints(trip);
      let chargersCopy = JSON.parse(JSON.stringify(this.chargers));

      for (let p of points) {
        for (let c of chargersCopy) {
          c.LatLng = { lat: c.Latitude, lng: c.Longitude };
          if (this.haversineDistance(c.LatLng, p) < metres) {
            routeChargers.push(c);
            chargersCopy = chargersCopy.filter((cc) => cc.ID !== c.ID);
          }
        }
      }
      return routeChargers;
    },
    chargersOnAllRoutes: function () {
      let metres = 5 * 1000; //Divert no more than 5km to find a charger
      let markers = [];
      let points = [];
      for (let trip of this.trips) {
        if (trip.path) {
          points = points.concat(this.getPoints(trip));
        }
      }
      let chargersCopy = JSON.parse(JSON.stringify(this.chargers));
      for (let p of points) {
        for (let c of chargersCopy) {
          let m = {};
          m.Name = c.Title;
          m.ID = c.ID;
          m.Current = c.Current;
          m.KwRated = c.KwRated;
          m.Charger = c;
          m.LatLng = { lat: c.Latitude, lng: c.Longitude };
          if (this.haversineDistance(m.LatLng, p) < metres) {
            markers.push(m);
            chargersCopy = chargersCopy.filter((cc) => cc.ID !== c.ID);
          }
        }
      }
      return markers;
    },
  },
  mounted: function () {
    //this.$vuetify.theme.dark = true;
    PowerTrip.getChargingStations().then((stations)  => {
      this.chargers = stations;
      this.updateRadarMarkers();
    });
    this.tab = parseInt(this.$route.params.id);
  },

  methods: {
          async updateRadarMarkers() {
        if (
          this.bubble.location.Address &&
          this.bubble.location.Address.geometry
        ) {
          let homeLocation = {
            lat: parseFloat(
              this.bubble.location.Address.geometry.coordinates[1]
            ),
            lng: parseFloat(
              this.bubble.location.Address.geometry.coordinates[0]
            ),
          };
          EVNav.chargerRadar(
            homeLocation,
            this.sortedCars[this.bubble.userPref],
            this.driver
          ).then((response) => this.radarChargers = response.data.chargers);
        } else {
          this.radarChargers = [];
        }
      },
    mapUpdated() {
      this.mapUpdate++;
    },
    findRecommendedCar(carList) {
      carList.sort((a, b) => (a.TCO === b.TCO ? 0 : a.TCO < b.TCO ? -1 : 1));
      let recommendedCar = carList[0];
      for (let i = 0; i < carList.length; i++) {
        carList[i].Recommended = i;
        if (i < 5) {
          carList[i].ListName =
            "★ " +
            carList[i].Name;
        } else {
          carList[i].ListName =
            carList[i].Name;
        }
      }
      carList.sort((a, b) =>
        a.Price === b.Price ? 0 : a.Price < b.Price ? -1 : 1
      );
      let idx = carList.indexOf(recommendedCar);
      this.bubble.userPref = idx;
      return idx;
    },
    clickedLocation(location) {
      this.radarChargers = [];
      let latlng = location.latlng || location.LatLng;
      this.bubble.location.Address = {
        Address: "",
        geometry: {
          coordinates: [latlng.lng, latlng.lat],
        },
      };
         this.$refs.myMap.centerMap(latlng);
      EVNav.reverseGeocode(latlng).then((data) => {
        this.bubble.location.Address = this.convertAddress(data);
        this.updateRadarMarkers()
      });
    },
    convertAddress(data) {
      var address = {};
      address.Address = data.display_name;
      address.geometry = {};
      address.geometry.coordinates = [];
      address.geometry.coordinates.push(data.lon);
      address.geometry.coordinates.push(data.lat);
      console.log(address);
      return address;
    },
    nextTab(index) {
      this.tab = index;
    },
    skipTab(index) {
      this.tab = index + 1;
    },
    getPoints(trip) {
      let points = [];
      if (trip.path.length > 0) {
        var startPoint = { lat: trip.path[0][0], lng: trip.path[0][1] };
        points.push(startPoint);
        for (let p of trip.path) {
          let pLatLng = { lat: p[0], lng: p[1] };
          if (this.haversineDistance(pLatLng, startPoint) > 500) {
            points.push(pLatLng);
            startPoint = pLatLng;
          }
        }
      }
      return points;
    },
  },
  components: {
    HomeBase,
    AddTrips,
    Map,
    Results,
  },
};
</script>

<style scoped>
.v-window-item {
  height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
.v-card > h2,
.subtitle {
  color: #1e88e5;
  font-weight: bold;
}
a {
  text-decoration: none;
}
.right {
  float: right;
}

.v-tabs-items.full-height-tab .v-window-item {
  height: calc(100vh - 160px); /* Adjust 270px to suits your needs */
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>